import React, { useEffect, useState } from "react"
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core"
import {
  ModalDeleteConfirm,
  TableHeader,
  IconButtonDatatable,
  Title,
  DatatablesFooterServerSide,
  Loading,
  TableCellDefault,
  InputOptionMaster,
  MasterButton,
} from "App/Component/ui"

import {
  FormMasterBarang,
  FormFilterMasterBarang,
  headCells,
  STYLE_MASTER_BARANG,
  RESET_STATE_MASTER_BARANG,
  deleteMasterBarangById,
  getByFilterBarang,
  RESET_STATE_FORM_FILTER,
  getById,
  urlGetWithTarif,
} from "./ui"

import { useDatatables, useDatatablesServerSide } from "App/hooks"
import {
  scrollToTop,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
  convertToValidPrice,
} from "App/utils/helpers"
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useTarifAsHeadCells } from "hooks"
import { defaultHeadCells } from "utils/all"
import { getAcccessSIMRS } from "redux/actions/Access"
import { FreezeTable } from "components/organism"

export default function GudangUtama() {
  const classes = STYLE_MASTER_BARANG()
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [rows, setRows] = useState([])
  const [formData, setFormData] = useState(RESET_STATE_MASTER_BARANG)
  const [barangId, setBarangId] = useState("")
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)
  const [totalData, setTotalData] = useState(0)
  const [access, setAccess] = useState(false)

  useEffect(() => {
    checkAccess()
  }, [])

  const checkAccess = async () => {
    const api = await getAcccessSIMRS("WMS_PBF_MS_BRG", "1")
    if (api.state) {
      setAccess(api.data)
    } else {
      setAccess(false)
    }
  }

  const handleClickUpdate = async (row) => {
    const barangById = await getById(row.id)

    if (barangById.state) {
      if (barangById.data.length > 0) {
        const data = barangById.data[0]
        setBarangId(row.id)
        setFormData({
          name: data?.name,
          satuanbeli_id: data?.satuanbeli_id,
          satuanbeli_name: data?.satuanBeli,

          satuanjual_id: data?.satuanjual_id,
          satuanjual_name: data?.satuanJual,

          qjb: data?.qjb,
          kode_produk: data?.kode_produk,
          komposisi: data?.komposisi,

          kelasterapi_id: data?.kelasterapi_id,
          kelasterapi_name: data?.namaKelasTerapi,

          golongan_id: data?.golongan_id,

          produsen_id: data?.produsen_id,
          produsen_name: data?.namaProdusen,

          jenisobat_id: data?.jenisobat_id,
          is_formularium: data?.is_formularium,

          tarifcbg_id: data?.tarifcbg_id,
          tarif_cbg: data?.namaTarifCbg,

          formula_id: data?.formula_id,
          formula_name: data?.namaFormula,

          stockmin: data?.stockmin,
          stockmax: data?.stockmax,
          nilaikritis: data?.nilaikritis,
          insurance_id: data?.insurance_id,
          golcoa_id: data?.golcoa_id,
          isformula: data?.isformula,
          barcode: data?.barcode,
          is_active: data?.is_active,
          status: isNull(data?.status) ? false : data?.status,

          // tidak diinput user
          harga_pokokAwal: convertToValidPrice(data.hargapokok),
          harga_pokok: convertToValidPrice(data.hargapokok),
          harga_pokok2: formatNumber(data.hargapokok),

          hargabeliAwal: convertToValidPrice(data.hargabeli),
          hargabeli: convertToValidPrice(data.hargabeli),
          hargabeli2: formatNumber(data.hargabeli),

          persediaan: formatNumber(row.qty_total * row.hargapokok),
          qty: row?.qty_total,

          // KFA
          kode_kfa_pa: data?.kode_kfa_pa ?? "",
          kode_kfa_pv: data?.kode_kfa_pv ?? "",
          kode_name: data?.kode_name ?? "",
          kode_kfa_pv_label: isNull(data?.kode_kfa_pv)
            ? "Pilih Kode KFA"
            : data?.kode_kfa_pv,
          bahan_baku_zat_aktif_kode_kfa_pa:
            data?.bahan_baku_zat_aktif_kode_kfa_pa ?? "",
          bahan_baku_numerator: data?.bahan_baku_numerator ?? "",
          bentuk_sediaan_kode: data?.bentuk_sediaan_kode ?? "",
        })
      }
    } else {
      defaultToastError(barangById.message)
    }
    scrollToTop()
  }

  const [loading, setLoading] = useState(false)

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    if (!isNull(formFilter.jenisharga_id)) {
      setLoading(true)

      const res = await getByFilterBarang(
        formFilter,
        pages,
        limit,
        urlGetWithTarif,
      )
      if (res.state) {
        setRows(res.data)
        setTotalData(res.meta.count)
        setLoading(false)
      } else {
        setRows([])
        setLoading(false)
        defaultToastError(res.message)
      }
    } else {
      defaultToastError("Pilih jenis harga terlebih dahulu")
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickDelete = (row) => {
    setBarangId(row.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  async function deleteList() {
    const res = await deleteMasterBarangById(barangId)
    if (res.state) {
      defaultToastSuccess(res.message)
      setNewData()
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  const handleClickReset = () => {
    setFormData(RESET_STATE_MASTER_BARANG)
    setBarangId("")
  }

  const { newHeadCells, headTarif } = useTarifAsHeadCells(
    headCells,
    defaultHeadCells,
  )

  return (
    <div className={classes.root}>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Title title="Master Barang" />

      <FormMasterBarang
        access={access}
        formData={formData}
        setFormData={setFormData}
        barangId={barangId}
        setBarangId={setBarangId}
        setNewData={setNewData}
        handleClickReset={handleClickReset}
      />

      <div className="mt-2">
        <Paper className={classes.paper}>
          <FormFilterMasterBarang
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            totalData={totalData}
            newHeadCells={newHeadCells}
            headTarif={headTarif}
          />

          <Loading show={loading} />
          <TableDaftarBarangDenganTarif
            rows={rows}
            classes={classes}
            handleClickUpdate={handleClickUpdate}
            handleClickDelete={handleClickDelete}
            newHeadCells={newHeadCells}
            headTarif={headTarif}
            formData={formData}
            setFormData={setFormData}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </div>
  )
}

export const TableDaftarBarangDenganTarif = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  isSelect = false,
  handleClickSelect,
  maxHeight = "auto",
  newHeadCells,
  headTarif,
  formData,
  setFormData,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "namaProdusen", "name"],
  })

  console.log(rows, "rows")

  return (
    <FreezeTable
      headCells={newHeadCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>
            <TableCell scope="row" padding="none" align="center">
              {isSelect ? (
                <>
                  <IconButtonDatatable
                    color="secondary"
                    aria-label="delete"
                    onClick={() => handleClickSelect(row)}
                    style={{
                      background: "#D8D8D8",
                      padding: "4px",
                    }}
                  >
                    <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
                  </IconButtonDatatable>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                  }}
                >
                  <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
                    <PencilIcon />
                  </IconButtonDatatable>

                  <IconButtonDatatable onClick={() => handleClickDelete(row)}>
                    <TrashIcon />
                  </IconButtonDatatable>
                </div>
              )}
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.name}</TableCell>
            <TableCell align="left">
              {row?.kode_kfa_pv ? row.kode_kfa_pv : "-"}
            </TableCell>
            <TableCell align="right">{formatNumber(row?.qty_total)}</TableCell>
            <TableCell align="right">{row?.satuanBeli ?? ""}</TableCell>
            <TableCell align="right">{row?.satuanJual ?? ""}</TableCell>
            <TableCell align="right">{formatNumber(row?.stockmin)}</TableCell>
            <TableCell align="right">{formatNumber(row?.stockmax)}</TableCell>
            <TableCell align="right">{formatNumber(row?.hargapokok)}</TableCell>
            <TableCell align="right">{formatNumber(row?.hargabeli)}</TableCell>
            <TableCell align="right">
              {formatNumber(row.qty_total * row.hargapokok)}
            </TableCell>
            <TableCell align="left">{row?.qjb}</TableCell>

            <TableCell align="left">{row?.namaProdusen}</TableCell>
            <TableCell align="left">{row?.nama_golongan_harga}</TableCell>
            <TableCell align="left">{row?.nama_kelas_terapi}</TableCell>
            <TableCell align="left">{row?.nama_golongan}</TableCell>
            <TableCell align="left">{row?.nama_jenis_obat}</TableCell>
            <TableCell align="left">{row?.nama_formula}</TableCell>

            <TableCell align="center">
              {row?.status ? (
                <>
                  <MasterButton name="Aktif" color="lightgreen" type="button" />
                </>
              ) : (
                <>
                  <MasterButton
                    name="Tidak Aktif"
                    color="secondary"
                    type="button"
                  />
                </>
              )}
            </TableCell>

            {headTarif.map((item, index) => {
              //ubah menjadi find
              const hargaSesuaiTarif = row.formulaharga.find(
                (hargaTarif) => hargaTarif.nama_tarif === item.id,
              )
              //
              // console.log(item)
              return (
                <>
                  <TableCell align="right" key={index}>
                    {isNull(hargaSesuaiTarif?.harga)
                      ? 0
                      : formatNumber(hargaSesuaiTarif.harga)}
                  </TableCell>
                </>
              )

              // return (
              //   <>
              //     <TableCell align='right' key={index}>
              //       {isNull(row.formulaharga[index]?.harga)
              //         ? 0
              //         : formatNumber(row.formulaharga[index].harga)}
              //     </TableCell>
              //   </>
              // );
            })}
            <TableCellDefault row={row} type="custom" />
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={newHeadCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}

export const TableDaftarBarang = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  isSelect = false,
  handleClickSelect,
  maxHeight = "auto",
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "namaProdusen", "name"],
  })

  return (
    <TableContainer
      className="custom-scrollbar"
      style={{
        maxHeight: maxHeight,
      }}
    >
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        size={"medium"}
        aria-label="enhanced table"
      >
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {isSelect ? (
                    <>
                      <IconButtonDatatable
                        color="secondary"
                        aria-label="delete"
                        onClick={() => handleClickSelect(row)}
                        style={{
                          background: "#D8D8D8",
                          padding: "4px",
                        }}
                      >
                        <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
                      </IconButtonDatatable>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <IconButtonDatatable
                        onClick={() => handleClickUpdate(row)}
                      >
                        <PencilIcon />
                      </IconButtonDatatable>

                      <IconButtonDatatable
                        onClick={() => handleClickDelete(row)}
                      >
                        <TrashIcon />
                      </IconButtonDatatable>
                    </div>
                  )}
                </TableCell>
                <TableCell align="left">{row?.id}</TableCell>
                <TableCell align="left">{row?.name}</TableCell>
                <TableCell align="left">{row?.qty_total}</TableCell>
                <TableCell align="right">
                  {formatNumber(row?.hargapokok)}
                </TableCell>

                <TableCell align="right">
                  {formatNumber(row?.hargabeli)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.qty_total * row.hargapokok)}
                </TableCell>

                <TableCell align="left">{row?.namaProdusen}</TableCell>
                <TableCellDefault row={row} type="custom" />
              </TableRow>
            )
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
